import _GenericNoResults from './generic-no-results.svg';

/** @deprecated Use @atlassian/jira-illustrations/src/ui/adg4/brand/spots/empty/components/search-no-results */
const GenericNoResults = _GenericNoResults;

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { GenericNoResults };
